import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
interface SigmaLogoTextProps {
  className?: string;
  height?: number;
  width?: number;
}

/**
 * The SIGMA word mark used on sigmaidentity.com, inlined so it inherits the
 * current text color. Same paths as sigma-auth-web/components/brand.
 */
export function SigmaLogoText(t0) {
  const $ = _c(8);
  const {
    className,
    width: t1,
    height: t2
  } = t0;
  const width = t1 === undefined ? 140 : t1;
  const height = t2 === undefined ? 32 : t2;
  let t3;
  if ($[0] !== className) {
    t3 = cn("fill-current", className);
    $[0] = className;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <title>Sigma</title>;
    t5 = <g><path d="M59.17,183.71c0,14.48,11.59,26.07,25.65,26.07,15.31,0,24.83-8.69,24.83-21.52,0-18.62-24.41-24-44.69-31.03C23.17,142.33,0,122.89,0,80.27S37.65,0,84.41,0c55.03,0,81.1,35.17,84.41,81.1h-57.1c0-14.07-8.69-25.65-25.65-25.65-13.24,0-26.07,7.86-26.07,24,0,18.62,22.76,21.93,43.86,28.14,44.27,13.24,64.96,38.07,64.96,76.96,0,43.86-37.24,80.27-83.99,80.27C30.62,264.8,0,228.39,0,183.71H59.17Z" /><path d="M209.77,8.28h60.82v248.25h-60.82V8.28Z" /><path d="M443.54,0c45.93,0,77.79,16.96,103.85,43.44l-42.2,38.89c-16.96-15.31-38.07-24.83-61.65-24.83-44.27,0-72.82,33.1-72.82,74.89,0,45.93,32.69,74.89,74.06,74.89,43.45,0,64.55-24,66.2-48h-70.75v-52.55h136.54v23.58c0,73.24-43.03,134.47-133.23,134.47-78.61,0-134.47-58.34-134.47-132.4S364.93,0,443.54,0Z" /><path d="M616.49,8.28h56.68l63.3,134.06L800.19,8.28h55.86v248.25h-60.41v-110.47l-54.2,118.75h-9.93l-54.2-119.58v111.3h-60.82V8.28Z" /><path d="M1003.34,0h10.76l121.64,256.53h-65.37l-12.41-25.65h-98.06l-12,25.65h-65.37L1003.34,0Zm33.93,187.43l-28.55-62.89h-.83l-28.96,62.89h58.34Z" /></g>;
    $[2] = t4;
    $[3] = t5;
  } else {
    t4 = $[2];
    t5 = $[3];
  }
  let t6;
  if ($[4] !== height || $[5] !== t3 || $[6] !== width) {
    t6 = <svg className={t3} height={height} viewBox="0 0 1135.74 256.53" width={width} xmlns="http://www.w3.org/2000/svg">{t4}{t5}</svg>;
    $[4] = height;
    $[5] = t3;
    $[6] = width;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
}